import { ContainerDefinition } from './types';

// ============================================================================
// Container Registry
// ============================================================================

/**
 * Central registry for all container definitions.
 * Containers are organizational units that group widgets together.
 */
const containerRegistry = new Map<string, ContainerDefinition>();

/**
 * Register a container definition
 */
export function registerContainer(definition: ContainerDefinition): void {
  if (containerRegistry.has(definition.id)) {
    console.warn(`Container "${definition.id}" is already registered. Skipping.`);
    return;
  }
  containerRegistry.set(definition.id, definition);
}

/**
 * Get a container definition by ID
 */
export function getContainer(id: string): ContainerDefinition | undefined {
  return containerRegistry.get(id);
}

/**
 * Get all registered containers
 */
export function getAllContainers(): ContainerDefinition[] {
  return Array.from(containerRegistry.values());
}

/**
 * Check if a container is registered
 */
export function isContainerRegistered(id: string): boolean {
  return containerRegistry.has(id);
}

/**
 * Get the count of registered containers
 */
export function getContainerCount(): number {
  return containerRegistry.size;
}

/**
 * Search containers by name or description
 */
export function searchContainers(query: string): ContainerDefinition[] {
  const lowerQuery = query.toLowerCase();
  return getAllContainers().filter(
    (container) =>
      container.name.toLowerCase().includes(lowerQuery) ||
      container.description.toLowerCase().includes(lowerQuery)
  );
}
